var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIconHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-.187.719-18.875-13.89A.5.5,0,0,0-19.187-14a.5.5,0,0,0-.391.187l-.312.39a.5.5,0,0,0-.11.313.5.5,0,0,0,.188.391L-1.125,1.89A.5.5,0,0,0-.813,2a.5.5,0,0,0,.391-.187l.313-.39A.5.5,0,0,0,0,1.11.5.5,0,0,0-.187.719ZM-10.725-9.423-6.513-6.13A3.491,3.491,0,0,0-10-9.5,3.493,3.493,0,0,0-10.725-9.423Zm1.451,6.846L-13.487-5.87A3.491,3.491,0,0,0-10-2.5,3.517,3.517,0,0,0-9.275-2.577ZM-10-10.5A8.5,8.5,0,0,1-2.565-6,8.891,8.891,0,0,1-3.94-4.119L-2.76-3.2A10.4,10.4,0,0,0-1.107-5.544,1.006,1.006,0,0,0-1-6a1.014,1.014,0,0,0-.108-.457A10.027,10.027,0,0,0-10-12a9.648,9.648,0,0,0-3.27.588l1.45,1.134A8.2,8.2,0,0,1-10-10.5Zm0,9A8.5,8.5,0,0,1-17.435-6a8.888,8.888,0,0,1,1.377-1.881L-17.238-8.8a10.4,10.4,0,0,0-1.653,2.347A1.006,1.006,0,0,0-19-6a1.014,1.014,0,0,0,.108.457A10.023,10.023,0,0,0-10,0,9.686,9.686,0,0,0-6.73-.588l-1.45-1.134A8.218,8.218,0,0,1-10-1.5Z",
    transform: "translate(20 14)",
    fill: "#3a3630"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIconHide);
export default __webpack_public_path__ + "static/media/settingsIcon_Hide.1544184edc822a37fddb6bc84b0ca258.svg";
export { ForwardRef as ReactComponent };